import styled from "styled-components";
import { colorsPalettes, mixins, setFontVariant } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import AutoCreatedTag from "../../../list-items/AutoCreatedTag/AutoCreatedTag";

export const StyledListWebsitesCount = styled.div`
    flex-shrink: 0;
    max-width: 50%;
    ${mixins.setFont({ $color: colorsPalettes.carbon["500"], $size: 14 })};
`;

export const StyledListName = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    margin-right: 5px;
`;

export const StyledListsDropdownItem = styled.div`
    align-items: center;
    background-color: ${colorsPalettes.carbon["0"]};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    transition: background-color 200ms ease-out;

    &:hover {
        background-color: ${colorsPalettes.bluegrey["200"]};
    }

    & > div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const StyledListDropdownGroupItem = styled.div`
    padding: 14px 16px;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])};
`;

export const StyledIcon = styled(SWReactIcons)`
    flex-shrink: 0;
    margin-right: 8px;
`;

export const StyledAssignedAccountsIcon = styled(StyledIcon)`
    path {
        fill: ${colorsPalettes.carbon[200]};
    }
`;

export const StyledAutoCreatedTag = styled(AutoCreatedTag)`
    margin-left: 4px;
`;
